import { ConnectButton } from "@rainbow-me/rainbowkit";
import { Link } from "react-router-dom";
import { RiRocketLine } from "@remixicon/react";
import { AppSidebar } from "@/components/app-sidebar";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/breadcrumb";
import { Separator } from "@/components/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/sidebar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/tabs";
import { SetupNodeAutomatic } from "@/components/silo/setup-node-automatic";
import { SetupNodeManual } from "@/components/silo/setup-node-manual";

export default function SiloSetupNodePage() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div className="px-4 md:px-6 lg:px-8 @container">
          <div className="w-full max-w-6xl mx-auto">
            <header className="flex flex-wrap gap-3 min-h-20 py-4 shrink-0 items-center transition-all ease-linear border-b">
              <div className="flex flex-1 items-center gap-2">
                <SidebarTrigger className="-ms-1" />
                <div className="max-lg:hidden lg:contents">
                  <Separator
                    orientation="vertical"
                    className="me-2 data-[orientation=vertical]:h-4"
                  />
                  <Breadcrumb>
                    <BreadcrumbList>
                      <BreadcrumbItem className="hidden md:block">
                        <BreadcrumbLink asChild>
                          <Link to="/">Home</Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator className="hidden md:block" />
                      <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                          <Link to="/silo">SILO</Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator className="hidden md:block" />
                      <BreadcrumbItem>
                        <BreadcrumbPage>Setup new node</BreadcrumbPage>
                      </BreadcrumbItem>
                    </BreadcrumbList>
                  </Breadcrumb>
                </div>
              </div>
              <ConnectButton />
            </header>

            <div className="py-6">
              <div className="flex justify-between items-start flex-wrap gap-3 mb-2">
                <div className="flex items-center">
                  <div className="w-1 h-8 bg-[#FF8A3C] mr-3" />
                  <h1 className="text-3xl font-bold">Setup new node</h1>
                </div>
                <div className="inline-flex items-center gap-2 rounded-md border border-[#FF8A3C]/40 bg-[#FF8A3C]/10 px-3 py-2 text-xs text-[#FFD3B3]">
                  <RiRocketLine className="size-4 text-[#FF8A3C]" />
                  Docker-based Silo storage node
                </div>
              </div>

              <p className="text-muted-foreground mb-8 max-w-3xl">
                Launch a Silo node with a guided compose wizard, or follow the official manual Docker steps.
              </p>

              <Tabs defaultValue="automatic" className="w-full">
                <TabsList className="mb-6">
                  <TabsTrigger value="automatic">Automatic</TabsTrigger>
                  <TabsTrigger value="manual">Manual</TabsTrigger>
                </TabsList>

                <TabsContent value="automatic" className="mt-0">
                  <SetupNodeAutomatic />
                </TabsContent>

                <TabsContent value="manual" className="mt-0">
                  <SetupNodeManual />
                </TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
